import React from "react";
import PropTypes from "prop-types";
import { Dimmer } from "semantic-ui-react";
import TopNav from "./TopNav";
import Loader from "../common/Loader";
import { getSettings } from "../../store/configureStore";
import LoaderTekstWithTimeout from "../common/LoaderTekstWithTimeout";

const PageHeader = (props) => {
	const title = props.title ? <h1 className="page-title">{props.title > 100 ? props.title.substring(0, 10) : props.title}</h1> : null;
	const subtitle = props.subtitle ? <div className="page-subtitle">{props.subtitle}</div> : null;
	const introText = props.intro ? <div className="page-intro one u-clear"><p>{props.intro}</p></div> : null;
	const topNav = props.showTopNav ?
		<TopNav topNavTabSettings={props.topNavTabSettings} scope={props.scope} disableTopNav={props.disableTopNav} /> : null;

	const timeout = parseInt(getSettings().spinnerTimeout);

	return (
		<section className="o-page__header">
			<div className="c-container u-clear">
				<div className="o-page__header__section">
					{title}
					{subtitle}
					{introText}
				</div>
				{topNav}
			</div>
			<Dimmer active={props.loading} page><Loader><LoaderTekstWithTimeout wait={timeout} /></Loader></Dimmer>
		</section>
	);
};

PageHeader.propTypes = {
	loading: PropTypes.bool.isRequired,
	title: PropTypes.string,
	intro: PropTypes.string,
	subtitle: PropTypes.string,
	showTopNav: PropTypes.bool.isRequired,
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string,
	disableTopNav: PropTypes.bool
};

export default PageHeader;
